import * as React from 'react';
import './surveyHeader.module.scss';
import { Logo } from '../../../../account/containers/navigation/Navigation';

export const SurveyHeader = ({ surveyName, surveyDescription = undefined, showLogo = true }) => (
  <div styleName="survey-header">
    {showLogo && (
      <div styleName="logo">
        <Logo />
      </div>
    )}
    <div styleName="survey-name">{surveyName}</div>
    {surveyDescription && (
      <div styleName="survey-description" dangerouslySetInnerHTML={{ __html: surveyDescription }} />
    )}
  </div>
);
